<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="btnLoadList" (click)="GetUserMasterList()" style="display:none">Get</button>
        <button type="button" id="btnDropChange" class="btn btn-block btn-primary float-sm-right" (click)="autoAssign()" style="display:none">DropChange</button>
        <button type="button" id="btnAutoAssign" (click)="autoAssignConfirm()" style="display:none">ArticleAllocate</button>
        <button type="button" id="btnDeleteDT" (click)="Delete()" style="display:none">Delete</button>
        <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>

        <div class="divContainer" style="top:1px;">
          <div class="col-12 col-sm-12">
            <div class="card card-primary card-outline card-outline-tabs">
              <div class="card-body">
                <div>
                  <button type="button" id="btn_AddNew" class="user-button btn btn-block btn-primary float-sm-right" (click)="PopupShow()" style="display:none">Add</button>

                  <table #dataTable class="display" style="width:100%"></table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Add/Update Popup-->
        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{title}}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>

              <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul" *ngIf="userMasterTabHide == false">
                <li class="nav-item"><a data-toggle="tab" href="#divGeneral" class="nav-link active">General</a></li>
                <li class="nav-item"><a data-toggle="tab" href="#divOthers" class="nav-link">Others</a></li>
                <li class="nav-item"><a data-toggle="tab" href="#divAllocation" class="nav-link">Allocation</a></li>
              </ul>

              <div class="modal-body">
                <!-- form start -->
                <form #form="ngForm">
                  <div class="tab-content">
                    <div class="tab-pane active" id="divGeneral">
                      <div class="row">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="txtFirstName">First Name:</label><em>*</em>
                                <input type="text" class="form-control" name="FirstName" id="txtFirstName" placeholder="First Name..." required maxlength="20">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="txtLastName">Last Name:</label><em>*</em>
                                <input type="text" class="form-control" name="LastName" id="txtLastName" placeholder="Last Name..." required maxlength="20">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="txt_LoginID">User Name:</label><span class="required">*</span>
                                <input type="text" name="LoginID" class="form-control" id="txtLoginID" placeholder="Enter User Name..." required maxlength="50">

                              </div>
                            </div>

                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="txtEmail">Email Id:</label><em>*</em>

                                <input type="email" name="EmailID" class="form-control" id="txtEmail" placeholder="Enter User Email..." required
                                       (change)="emailidOnly($event)" maxlength="120">

                                <input type="hidden" name="hdnEmailID" id="hdnEmailID" />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <div class="form-group">
                                <label>First Line Manager</label>
                                <select id="ddlManager1"  class="form-control" required>
                                  <option [value]="0" selected="selected">Select</option>
                                  <option *ngFor="let item of userMasterList" value={{item.UserID}}>{{item.LoginName}}</option>
                                </select>

                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Second Line Manager</label>
                                <select id="ddlManager2" class="form-control" required>
                                  <option [value]="0" selected="selected">Select</option>
                                  <option *ngFor="let item of userMasterList" value={{item.UserID}}>{{item.LoginName}}</option>
                                </select>
                              </div>
                            </div>

                          </div>

                          <div class="row">

                            <div class="col-md-6" style="display:none">
                              <div class="form-group">
                                <label>Phone No:</label>
                                <input type="text" OnlyNumber name="PhoneNo" id="txtPhoneNo" class="form-control IsNumeric" maxlength="10">
                              </div>
                            </div>

                          </div>

                          <div class="row">

                            <div class="col-md-6">
                              <div class="form-group">
                                <label>User Role:</label><em>*</em>
                                <select id="ddlRole" name="RoleID" class="form-control select2" required>
                                  <option [value]="0" selected="selected">Select</option>
                                  <option *ngFor="let item of roleMasterList" value={{item.RoleID}}>{{item.RoleName}}</option>
                                </select>

                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Active Status:</label><em>*</em>
                                <select id="ddlActiveStatus" name="ActiveStatus" class="form-control select2">
                                  <option>Active</option>
                                  <option>InActive</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-12">
                              <div class="form-group unavailable">
                                <input type="checkbox" id="chkIsLeave">
                                <label>Un Availability</label>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <label>From</label>
                              <input type="date" name="FromDate" class="form-control float-right" id="Txt_UAStartDate" (change)="UAEndMinDate()" autocomplete="off">
                            </div>
                            <div class="col-sm-6">
                              <label>To</label>
                              <input type="date" name="ToDate" class="form-control float-right" id="Txt_UAEndDate" autocomplete="off">
                            </div>

                          </div>

                        </div>

                      </div>
                    </div>
                    <button type="button" id="btnGetPubJournal" (click)="GetJournalList()" style="display:none">JournalList</button>
                    <div class="tab-pane" id="divOthers">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group">
                            Access DepartmentList
                            <select id="ddlDepartmentList" class="form-control" multiple>
                              <option *ngFor="let item of Dropdownapi" value={{item.Id}}>
                                {{item.DepartmentName}}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-12">
                          <div class="form-group">
                            Access Publisher
                            <select id="lstPublihsers" class="form-control" multiple onchange="$('#btnGetPubJournal').trigger('click');">
                              <option *ngFor="let item of modelItem.publisherMasterList" value={{item.ID}}>
                                {{item.PublisherCode}}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-12">
                          <div class="form-group">
                            Access Journal
                            <select id="lstJournals" class="form-control" multiple>
                              <option *ngFor="let item of modelItem.journalMasterList" value={{item.ID}}>
                                {{item.JournalCode}}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="tab-pane" id="divAllocation">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            Shift
                            <select id="ddlShiftList" class="form-control">
                              <option value="First Shift">First Shift</option>
                              <option value="Second Shift">Second Shift</option>
                              <option value="General Shift">General Shift</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            Weekend Group
                            <select id="ddlGroup" class="form-control">
                              <option value="Group 1">Group 1</option>
                              <option value="Group 2">Group 2</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="form-group">
                            Allocation Publisher
                            <select id="lstAllocatePublihsers" class="form-control" multiple>
                              <option *ngFor="let item of modelItem.publisherMasterList" value={{item.ID}}>
                                {{item.PublisherCode}}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="form-group">
                            Allocation Activity
                            <select id="lstAllocatedActivity" class="form-control" multiple>
                              <option *ngFor="let item of modelItem.activityList" value={{item.ID}}>
                                {{item.Activity}}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            Article Count
                            <input type="text" class="form-control" name="" id="txtArticleCount" placeholder="" isnumeric required maxlength="20">
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            Max Pages
                            <input type="text" class="form-control" name="" id="txtMaxPages" placeholder="" isnumeric required maxlength="20">
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <input type="checkbox" id="chkAutoAssign">
                            &nbsp;<label>Auto Assign</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </form>
              </div>
              <!-- Modal footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="submit" (click)="onSubmit()" class="btn btn-outline-success waves-effect waves-light" value="Update">{{popUpButtonText}}</button>
              </div>

              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
